export default __webpack_public_path__ + "static/Milonga_de_mis_amores-7b797943557e7c43067edf80a5569191.mp3";